import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Tab, Header, Checkbox, Button } from 'semantic-ui-react';
import styled from 'styled-components';
import MenuForDay from './MenuForDay';
import { transformRecurringMenuStructure, checkUnwantedFood } from '../../../actions/menu';
import { showBasket } from '../../../actions/basket';
import { SMALLER_DAY_VIOLATION, BIGGEST_DAY_VIOLATION } from '../../../constants/appConstants';

const MenuBlock = React.memo(
  ({
    daysCount,
    setActiveDayTab,
    activeDayTab,
    menu,
    changeDishPortion,
    changeDish,
    addDish,
    deleteDish,
    changeMealTime,
    changeDishTime,
    toggleChangeTheSameDays,
    isChangeTheSameDays,
    sameDaysCount,
    setMenuMenuGenerator,
    unwantedFoodDay,
    templateTagsFilters,
    checkUnwantedFood,
    category,
    selectedComplex,
    showBasket,
    userCurrentDay,
    countTotalFitValuesByDay,
    daysViolations,
    cbgucalories,
    isCreateTemplate = false,
  }) => {
    useEffect(() => {
      const transformMenu = transformRecurringMenuStructure(menu, sameDaysCount);
      setMenuMenuGenerator(transformMenu);
    }, [sameDaysCount]);

    const onTabChange = (e, data) => {
      setActiveDayTab(data.activeIndex);
    };
    useEffect(() => {
      category ? checkUnwantedFood(menu, category) : checkUnwantedFood(menu);
    }, [templateTagsFilters, category, menu]);

    const dayPanes = [];
    for (let dayIndex = 0; dayIndex < daysCount; dayIndex++) {
      let dayPanelValue = '';
      if (
        daysViolations &&
        daysViolations[dayIndex] &&
        daysViolations[dayIndex].violations === SMALLER_DAY_VIOLATION
      ) {
        dayPanelValue = {
          key: `${dayIndex + 1}`,
          icon: 'arrow down',
          content: `${dayIndex + 1}`,
        };
      } else if (
        daysViolations &&
        daysViolations[dayIndex] &&
        daysViolations[dayIndex].violations === BIGGEST_DAY_VIOLATION
      ) {
        dayPanelValue = {
          key: `${dayIndex + 1}`,
          icon: 'arrow up',
          content: `${dayIndex + 1}`,
        };
      } else if (userCurrentDay === dayIndex + 1) {
        dayPanelValue = {
          key: `${dayIndex + 1}`,
          icon: 'calendar check outline',
          content: `${dayIndex + 1}`,
        };
      } else dayPanelValue = `${dayIndex + 1}`;

      dayPanes.push({
        menuItem: dayPanelValue,
        render: () => (
          <Tab.Pane attached={false}>
            <MenuForDay
              dayNumber={dayIndex + 1}
              mealsData={menu[dayIndex]}
              changeDishPortion={changeDishPortion}
              changeDish={changeDish}
              addDish={addDish}
              deleteDish={deleteDish}
              changeMealTime={changeMealTime}
              changeDishTime={changeDishTime}
              countTotalFitValuesByDay={countTotalFitValuesByDay}
              cbgucalories={cbgucalories}
              dayViolation={daysViolations ? daysViolations[dayIndex] : null}
              isCreateTemplate={isCreateTemplate}
            />
          </Tab.Pane>
        ),
      });
    }
    return (
      <MenuBlockWrap>
        <Header as="h1" textAlign="center">
          <div>Меню</div>
          {selectedComplex && selectedComplex.startDate && (
            <div>
              <Button primary onClick={showBasket}>
                Показать Корзину
              </Button>
            </div>
          )}
          <Checkbox
            label="Изменять одинаковые дни"
            style={{ marginLeft: '20px', fontWeight: 'normal' }}
            onChange={toggleChangeTheSameDays}
            checked={isChangeTheSameDays}
          />
          {!!unwantedFoodDay.length && (
            <UnwantedFoodDayMessage>
              * исключенные продукты найдены в таких днях: {unwantedFoodDay.join(' ')}
            </UnwantedFoodDayMessage>
          )}
          {userCurrentDay !== 0 && (
            <CurrentUserDayMessage>Текущий день курса: {userCurrentDay}</CurrentUserDayMessage>
          )}
        </Header>
        <Tab
          panes={dayPanes}
          onTabChange={onTabChange}
          activeIndex={activeDayTab}
          menu={{
            color: 'blue',
            borderless: true,
            attached: false,
            tabular: false,
          }}
        />
      </MenuBlockWrap>
    );
  },
);

const mapStateToProps = (state) => {
  const { unwantedFoodDay } = state.menu;
  const { templateTagsFilters, userCurrentDay } = state.templateGenerator;
  const { selectedComplex } = state.complex;
  const { cbgucalories } = state.calculateCbgu;

  return {
    unwantedFoodDay,
    templateTagsFilters,
    selectedComplex,
    userCurrentDay,
    cbgucalories,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showBasket: () => {
    dispatch(showBasket());
  },
  checkUnwantedFood: (menu, category) => {
    dispatch(checkUnwantedFood(menu, category));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuBlock);

const MenuBlockWrap = styled.div`
  width: 85%;
  margin: 5px auto;
`;

const UnwantedFoodDayMessage = styled.p`
  margin: 5px auto;
  font-size: 16px;
  color: rgb(245, 170, 179);
`;

const CurrentUserDayMessage = styled.p`
  margin: 5px auto;
  font-size: 16px;
  color: '#157aac';
`;



// WEBPACK FOOTER //
// ./src/Components/Common/MenuBlock/index.jsx